import { render, staticRenderFns } from "./funding.vue?vue&type=template&id=1f6fc866"
import script from "./funding.vue?vue&type=script&lang=js"
export * from "./funding.vue?vue&type=script&lang=js"
import style0 from "./funding.vue?vue&type=style&index=0&id=1f6fc866&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports